module.exports = __webpack_public_path__ + "static/media/pvsa.96cd5038.png";